import React from 'react';
import { company } from '../mock';

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-serif text-2xl md:text-3xl mb-4">{title}</h2>
    <div className="text-black/75 leading-relaxed space-y-3">{children}</div>
  </section>
);

const Legal = () => {
  return (
    <div className="pt-[72px] bg-white">
      <section className="bg-black text-white py-16">
        <div className="max-w-[900px] mx-auto px-6 lg:px-10">
          <p className="text-[11px] tracking-[0.4em] uppercase text-white/60">Légal</p>
          <h1 className="font-serif text-5xl md:text-6xl mt-3">Mentions légales</h1>
        </div>
      </section>

      <article className="py-16">
        <div className="max-w-[900px] mx-auto px-6 lg:px-10 text-[15px]">
          <Section title="1. Éditeur du site">
            <p><strong>Raison sociale</strong> : Ha Transport — SARL</p>
            <p><strong>Adresse du siège social</strong> : {company.address}</p>
            <p><strong>Téléphone</strong> : {company.phone}</p>
            <p><strong>E-mail</strong> : <a className="underline" href={`mailto:${company.email}`}>{company.email}</a></p>
            <p><strong>SIRET</strong> : 852 154 970 00010</p>
            <p><strong>RCS</strong> : 852 154 970</p>
            <p><strong>N° d'inscription au registre VTC</strong> : EVTC 093 19 146</p>
            <p><strong>Capital social</strong> : [À compléter]</p>
            <p><strong>TVA intracommunautaire</strong> : [À compléter]</p>
          </Section>

          <Section title="2. Directeur de la publication">
            <p>Monsieur <strong>Hammou Ali Ahmed</strong>, en qualité de gérant.</p>
          </Section>

          <Section title="3. Hébergement">
            <p>Le site <strong>hatransport.fr</strong> est hébergé par :</p>
            <p>
              <strong>OVH SAS</strong><br />
              2 rue Kellermann — 59100 Roubaix — France<br />
              Téléphone : 1007 (depuis la France)<br />
              Site web : <a className="underline" href="https://www.ovh.com" target="_blank" rel="noreferrer">www.ovh.com</a>
            </p>
          </Section>

          <Section title="4. Propriété intellectuelle">
            <p>
              L'ensemble des contenus présents sur le site hatransport.fr (textes, images, vidéos, logos,
              graphismes, icônes) est la propriété exclusive de Ha Transport ou de ses partenaires,
              et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle.
            </p>
            <p>
              Toute reproduction, représentation, modification, publication, adaptation, totale ou partielle,
              des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans
              autorisation écrite préalable de Ha Transport.
            </p>
          </Section>

          <Section title="5. Données personnelles">
            <p>
              Les informations recueillies via le formulaire de contact ou de réservation font l'objet
              d'un traitement informatique destiné à la gestion de votre demande de prestation de transport.
            </p>
            <p>
              Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi
              « Informatique et Libertés », vous disposez d'un droit d'accès, de rectification, de
              suppression et d'opposition aux données vous concernant. Vous pouvez exercer ces droits
              en écrivant à <a className="underline" href={`mailto:${company.email}`}>{company.email}</a>.
            </p>
            <p>Voir notre <a className="underline" href="/confidentialite">Politique de confidentialité</a>.</p>
          </Section>

          <Section title="6. Cookies">
            <p>
              Le site hatransport.fr utilise des cookies techniques nécessaires à son bon fonctionnement
              (préférence de langue, brouillon de réservation). Aucun cookie publicitaire ni de suivi tiers
              n'est déposé sans votre consentement.
            </p>
          </Section>

          <Section title="7. Loi applicable et juridiction">
            <p>
              Les présentes mentions légales sont régies par la loi française. En cas de litige, et après
              tentative de résolution amiable, les tribunaux français seront seuls compétents.
            </p>
          </Section>

          <p className="text-xs text-black/50 mt-12">Dernière mise à jour : mai 2026</p>
        </div>
      </article>
    </div>
  );
};

export default Legal;
